import { Injectable, NgZone } from "@angular/core";
import { AuthService } from "./auth.service";

@Injectable({
    providedIn: "root",
})
export class IdleTimeoutService {
    private static readonly TIMEOUT_MS = 8 * 60 * 60 * 1000;
    private static readonly ACTIVITY_EVENTS = ["mousemove", "mousedown", "keydown", "touchstart", "scroll", "click"];

    private timeoutId: ReturnType<typeof setTimeout> | null = null;
    private readonly boundResetTimer = () => this.resetTimer();
    private started = false;

    constructor(
        private readonly ngZone: NgZone,
        private readonly authService: AuthService
    ) { }

    start(): void {
        if (this.started) return;
        this.started = true;

        this.ngZone.runOutsideAngular(() => {
            IdleTimeoutService.ACTIVITY_EVENTS.forEach((eventName) =>
                document.addEventListener(eventName, this.boundResetTimer, { passive: true })
            );
            this.resetTimer();
        });
    }

    stop(): void {
        if (!this.started) return;
        this.started = false;

        IdleTimeoutService.ACTIVITY_EVENTS.forEach((eventName) =>
            document.removeEventListener(eventName, this.boundResetTimer)
        );

        if (this.timeoutId) {
            clearTimeout(this.timeoutId);
            this.timeoutId = null;
        }
    }

    private resetTimer(): void {
        if (this.timeoutId) clearTimeout(this.timeoutId);

        this.timeoutId = setTimeout(() => {
            this.ngZone.run(() => this.authService.logout());
        }, IdleTimeoutService.TIMEOUT_MS);
    }
}
